import PropTypes from 'prop-types';
import React, { memo } from 'react';

import style from './style.module.css';

const AppHeaderTitleComponent = ({ overline, title }) => (
  <div className={style.host}>
    <div className={style.divider} />
    <div className={style.info}>
      <span className={style.overline}>{overline}</span>
      <span className={style.name}>{title}</span>
    </div>
  </div>
);

AppHeaderTitleComponent.propTypes = {
  overline: PropTypes.node.isRequired,
  title: PropTypes.node,
};

/** Page title (overline + title) shown inside the app header, e.g. "Contact / Jamie Busic". */
export const AppHeaderTitle = memo(AppHeaderTitleComponent);
